import axios from 'axios'
import { Elevation } from '~/models'
import PagedResponse from '~/models/pagedResponse'
import { $axios } from '~/utils/api'

const END_POINT = '/elevations'

const CancelToken = axios.CancelToken
const cancelTokens: {
  ['elevations-approved']: any
  ['elevations-pending']: any
  ['elevations-denied']: any
} = {
  'elevations-approved': null,
  'elevations-pending': null,
  'elevations-denied': null,
}

const cancelPreviousToken = (name: string): void => {
  if (cancelTokens[name]) {
    cancelTokens[name].cancel()
    cancelTokens[name] = null
  }
}

const getElevations = (
  style?: string | number,
  lot?: string | number,
  status?: string | number,
  page?: number | string,
  pageSize?: number | string,
  orderBy?: string,
  project?: string,
  builderId?: number,
  variance: boolean = false,
  planId?: number,
  consumerMapFilters?: string,
  am: boolean = true,
  search?: string
): Promise<PagedResponse<Elevation>> => {
  const params: Array<string> = []
  params.push(style ? `style_id=${style}` : null)
  params.push(lot ? `lot_id=${lot}` : null)
  params.push(page ? `page=${page}` : null)
  params.push(status ? `status=${status}` : null)
  params.push(pageSize ? `page_size=${pageSize}` : null)
  params.push(orderBy ? `order_by=${orderBy}` : null)
  params.push(project ? `project=${project}` : null)
  params.push(builderId ? `builder_id=${builderId}` : null)
  params.push(variance ? `variance=${variance}` : null)
  params.push(planId ? `plan_id=${planId}` : null)
  params.push(consumerMapFilters || null)
  params.push(`am=${am}`)
  params.push(search ? `search=${search}` : null)

  const request = `${END_POINT}?${params.filter((param) => !!param).join('&')}`
  const identifier = 'elevations' + '-' + status

  cancelPreviousToken(identifier)

  cancelTokens[identifier] = CancelToken.source()
  return $axios.$get(request, {
    cancelToken: cancelTokens[identifier].token,
  })
}

const getElevation = (id: number, params: any = {}): Promise<Elevation> =>
  $axios.$get(`${END_POINT}/${id}`, { params })

export { getElevations, getElevation }
